(($, Drupal, once) => {
  Drupal.behaviors.ga_custom_events = {
    attach: function(context, settings) {
      // Push media info to dataLayer when user clicks on download report button
      $('.download-report').once('report-download-custom-event').on('click', function(e) {
        const $media_id = $(this).attr('data-media-id');
        const $media_label = $(this).attr('data-media-label');
        const $user_id = $(this).attr('data-user-id');
        window.dataLayer.push({
          event: 'report_download',
          data: {
            user_id: $user_id,
            file_id: $media_id,
            file_label: $media_label
          }
        });

        console.log(window.dataLayer);
      });
    }
  };
})(jQuery, Drupal, once);
